export const servicesData = [
    {
        id: 1,
        bgcolor:'cyan',
        imageUrl: 'https://res.cloudinary.com/dvjbswt50/image/upload/v1717394783/spc/pngwing.com_11_lh2jli.png',
        title: 'Pet Accessories',
        description: 'Discover a wide range of high-quality pet accessories at our shop. From stylish collars and leashes to cozy beds and fun toys, we have everything to keep your pet happy and comfortable. Our selection includes products for dogs, cats, birds, and small animals. Visit us to find the perfect accessories for your beloved pet!'
    },
    {
        id: 2,
        bgcolor: 'yellow',
        imageUrl: 'https://res.cloudinary.com/dvjbswt50/image/upload/v1717393629/spc/pngwing.com_5_xdayby.png',
        title: 'Premium Pet Food',
        description: 'Ensure your pet gets the nutrition they deserve with our wide selection of premium pet food. We offer top brands and specialized formulas to meet the dietary needs of dogs, cats, birds, and small animals. From dry kibble and wet food to treats and supplements, we have everything to keep your pet healthy and happy.'
    },
    {
        id: 5,
        bgcolor: 'lime',
        imageUrl: 'https://res.cloudinary.com/dvjbswt50/image/upload/v1717394799/spc/pngwing.com_12_g3zblh.png',
        title: 'Pet Clinic',
        description: 'Ensure your pet receives the best medical care with our state-of-the-art pet clinic facilities. Our compassionate and skilled veterinarians provide a full range of services, including routine check-ups, diagnostic testing, surgical procedures, vaccination, and emergency care. Visit us for exceptional veterinary care and personalized attention for your furry family member.'
    },
    {
        id: 4,
        bgcolor: 'orange',
        imageUrl: 'https://res.cloudinary.com/dvjbswt50/image/upload/v1717394487/spc/pngwing.com_10_kuveju.png',
        title: 'Buy Pet',
        description: 'Looking to add a new member to your family or find a loving home for your pet? Our buy and sell pet service connects pet lovers with the perfect companions. Browse our selection of healthy and well-cared-for pets ready for adoption. Visit us to meet your new furry friend or to discuss rehoming options. Contact us to know more.'
    },
    {
        id: 3,
        bgcolor: 'pink',
        imageUrl: 'https://res.cloudinary.com/dvjbswt50/image/upload/v1717349487/spc/pngwing.com_2_hdjvvy.png',
        title: 'Pet Grooming',
        description: 'Pamper your furry friend with our professional pet grooming services. Our experienced groomers ensure a stress-free and enjoyable grooming experience, leaving your pet looking and feeling their best. Services include bathing, haircuts, nail trimming, ear cleaning, and more. Book an appointment today for a fresh and clean pet!'
    },
]